import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/site/Motion";
import { LogoMark } from "@/components/site/Logo";

export const CtaBand = ({ title = ["Se Redoc i", "praktiken."], text = "Boka en kostnadsfri demo eller begär mer information – så återkommer vi inom kort." }) => (
  <section className="px-4 sm:px-6 lg:px-10 pb-24" data-testid="cta-band">
    <div className="relative max-w-[1400px] mx-auto overflow-hidden rounded-[32px] bg-[#0B14A0] text-white px-8 sm:px-14 py-16 sm:py-24 grain">
      <div aria-hidden="true" className="absolute -right-24 -bottom-24 opacity-25">
        <LogoMark className="w-[460px] h-[460px]" />
      </div>
      <div className="relative grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <MaskedLines as="h2" inView className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold tracking-[-0.035em] leading-[0.95]" lines={title} />
          <Reveal delay={0.2}><p className="mt-6 max-w-xl text-lg text-[#D5D8F0]">{text}</p></Reveal>
        </div>
        <Reveal className="lg:col-span-4 lg:justify-self-end" delay={0.25}>
          <Link to="/kontakt?subject=Boka%20demo" data-testid="cta-band-button" className="group inline-flex items-center gap-3 rounded-full bg-white text-[#070B2E] pl-7 pr-2 py-2 font-semibold transition-[background-color] duration-300 hover:bg-[#7FE3EA]">
            Boka demo
            <span className="grid place-items-center w-11 h-11 rounded-full bg-[#070B2E] text-white transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight className="w-4 h-4" /></span>
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
